import React from "react";

function UserPagesLayout({ children }) {
  // Corrected 'children'
  return <div className="justify-start mx-auto w-10/12 mt-5">{children}</div>; // Removed {}
}

export default UserPagesLayout;
